import * as images from "../../assets/img/skills";

export default [
  {
    name: "HTML5",
    image: images.HTML5,
    url: "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5",
  },
  {
    name: "CSS3",
    image: images.CSS3,
    url: "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS3",
  },
  {
    name: "JavaScript",
    image: images.JavaScript,
    url: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    name: "NodeJS",
    image: images.NodeJS,
    url: "https://nodejs.org/en/",
  },

  {
    name: "React",
    image: images.React,
    url: "https://facebook.github.io/react/",
  },
  {
    name: "Firebase",
    image: images.Firebase,
    url: "https://facebook.github.io/react/",
  },
  {
    name: "Vue",
    image: images.Vue,
    url: "https://vuejs.org/",
  },
  {
    name: "Git",
    image: images.Git,
    url: "https://git-scm.com/",
  },
  {
    name: "Express",
    image: images.Express,
    url: "https://expressjs.com/",
  },
  {
    name: "MongoDB",
    image: images.MongoDB,
    url: "https://www.mongodb.com/",
  },
  {
    name: "Mocha",
    image: images.Mocha,
    url: "https://mochajs.org/",
  },
  {
    name: "Chai",
    image: images.Chai,
    url: "https://www.chaijs.com/",
  },
  // {
  //   name: "jQuery",
  //   image: images.jQuery,
  //   url: "https://jquery.com/",
  // },
  {
    name: "Postgree",
    image: images.Postgree,
    url: "https://www.postgresql.org/",
  },
  // {
  //   name: "Vuetify",
  //   image: images.Vuetify,
  //   url: "https://vuetifyjs.com/",
  // },
  // {
  //   name: "Bootstrap",
  //   image: images.Bootstrap,
  //   url: "https://getbootstrap.com/",
  // },
  {
    name: "Webpack",
    image: images.Webpack,
    url: "https://webpack.js.org/",
  },

  {
    name: "Sass",
    image: images.Sass,
    url: "http://sass-lang.com/",
  },
];



// WEBPACK FOOTER //
// ./src/components/Skills/skills.js